module.exports = __webpack_public_path__ + "static/media/ic_arrow_right_white.bb05d359.svg";